import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { connect } from 'react-redux';
import { Apify } from '../Apify';
import Logo from './Logo';
import { R } from '../routes';
import { T, TraksConsumer } from '../traks';
import { short_site_id } from '../Site';
import { validatePremium } from '../misc';


class SearchResult extends Component {
	constructor(props) {
		super(props);
		this.result_refs = [];
	}

	componentDidMount() {
		const try_focus = (i) => {
			if (this.props.results.length > 0 && this.result_refs[i]) {
				ReactDOM.findDOMNode(this.result_refs[i]).focus();
			}
		};
		this.props.set_focuser({
			first: () => {
				try_focus(0);
			},
			last: () => {
				try_focus(this.props.results.length-1);
			},
		});
	}

	componentWillUnmount() {
		this.props.set_focuser(null);
		this.result_refs = [];
	}

	render() {
		const ref_for_i = (i) => (ref) => {
			this.result_refs[i] = ref;
		};

		const keydown_for_i = (i) => (e) => {
			if (i === 0 && e.key === "ArrowUp") {
				e.preventDefault();
				this.props.focus_search_input();
			}
			if (i === this.props.results.length-1 && e.key === "ArrowDown") {
				e.preventDefault();
				this.props.focus_search_input();
			}
		};

		const set_default_action = (fn) => { this.props.set_default_action(fn); };

		set_default_action(null);

		var results = [];
		for (var i = 0; i < this.props.results.length; i++) {
			const x = this.props.results[i];

			const exchange = x.Exchange;
			const ticker = x.Ticker;
			const name = x.Name;
            const type = x.Type;
			const key = `${exchange}\x00${ticker}`;
			const click = () => {
				if (this.props.on_action) this.props.on_action();
				R.go("/ticker/:exchange/:ticker", {exchange, ticker});
			};

            const typeGetter = () => {
                if (type === 'ETF') {
                    return <T>ETF</T>
                } else if (type === 'Index') {
                    return <T>Index</T>
                } else if (type === 'Commodity') {
                    return <T>Commodity</T>
                } else if (type === 'Funds/Obligations') {
                    return <T>Funds / Bonds</T>
                } else {
                    return <T>Stock</T>
                }
            }
			if (i === 0) set_default_action(click);

			let xlogo;
			switch (exchange.toUpperCase()) {
			case "NASDAQ":
			case "NYSE":
				xlogo = "/gfx/usa-icon-0.svg"
				break;
			case "CPH":
				xlogo = "/gfx/denmark-icon-0.svg";
				break;
			case "STO":
				xlogo = "/gfx/sweden-icon-0.svg";
				break;
			case "HEL":
				xlogo = "/gfx/finland-icon-0.svg";
				break;
			case "ICE":
				xlogo = "/gfx/iceland-icon-0.svg";
				break;
			case "CRYPTO":
				xlogo = "/gfx/crypto-icon-0.svg";
				break;
			case "BANK":
				xlogo = "/gfx/currencies-0.svg";
				break;
			case "IDX-USD":
			case "IDX-DKK":
			case "IDX-SEK":
			case "IDX-HEL":
				xlogo = "/gfx/index-icon-0.svg";
				break;
			case "XETRA":
				xlogo = "/gfx/germany-icon-0.svg";
				break;
			case "WBAG":
				xlogo = "/gfx/austria-icon-0.svg";
				break;
			case "OPEC":
			case "LBMA":
			case "LME":
			case "BRENT":
			default:
				xlogo = "/gfx/commodities-icon-0.svg";
				break;
			}

			var item_classes = "ad_ellipsis ad_thin_bottom p-md-2";
			var text_classes = "font-small ad_gray_fg pl-2";
			var extra;

			results.push(
				<DropdownItem key={key} ref={ref_for_i(i)} onKeyDown={keydown_for_i(i)} onClick={click} className={item_classes}>
					<img
						alt=""
						className="mr-3 ad_lang_img"
						src={xlogo}
					/>
					<Logo
						size={24}
						exchange={exchange}
						ticker={ticker}
						className="mr-3"
					/>
					<span className={text_classes}>{ticker} &mdash; {name} &mdash; {typeGetter()}</span>
					{extra}
				</DropdownItem>
			);
		}

		return results.length === 0 ? <div>No results</div> : <div>{results}</div>;
	}
}

SearchResult = Apify("/z/search")
	.with_query_from_props((props) => {
		const q = props.query;
		if (q.trim().length === 0) {
			return null;
		}
		return {site: short_site_id, n:10, q: props.query, market: props.market, lang: R.get_current_language()};
	})
	.with_props_from_response(response => ({results: response || []}))
	.wrap(SearchResult);


class SearchFieldImpl extends Component {
	constructor(props) {
		super(props);
		this.state = {query: ""};
		this.focuser = null;
		this.search_input_ref = null;
		this.default_action = null;
	}

	componentWillUnmount() {
		this.search_input_ref = null;
	}

	render() {
		const isPremium = this.props.me ? validatePremium(this.props.me) : false;
		const show_popover = this.state.query.length > 0;
		const close = () => {
			this.setState({query: ""});
		};
		const search = (e) => {
			this.setState({query: e.target.value});
		};

		const search_value = this.state.query;
		const search_id = this.props.input_id;
		const input_classes = this.props.input_classes || "col-form-label-sm ad_search_navbar ad_no_outline_focus ad_rounded_search ad_input_search_frontpage";
		var form_classes = this.props.form_classes || "";

		form_classes = "form-inline my-0 my-lg-0 " + form_classes;

		const set_focuser = (focuser) => {
			this.focuser = focuser;
		};

		const arrow_nav = (e) => {
			if (!this.focuser) return;
			if (e.key === "ArrowDown") {
				e.preventDefault();
				this.focuser.first();
			} else if (e.key === "ArrowUp") {
				e.preventDefault();
				this.focuser.last();
			}
		};

		const focus_search_input = () => {
			/* XXX don't know why I need this setTimeout(), but
			 * focus doesn't work otherwise :-/ */
			setTimeout(() => {
				if (this.search_input_ref) {
					this.search_input_ref.focus();
				}
			}, 0);

		};

		const set_search_input_ref = (ref) => {
			this.search_input_ref = ref;
		}

		var placeholder = <T>Search securities</T>;
		placeholder = this.props.render_static(placeholder);

		if (this.props.placeholder) {
			if(this.props.placeholder instanceof String) {
				placeholder = this.props.placeholder;
			} else {
				placeholder = this.props.render_static(this.props.placeholder);
			}
		}

		const search_submit = (e) => {
			e.preventDefault();
			if (this.default_action) this.default_action();
			this.setState({query: ""});
		}

		const set_default_action = (fn) => {
			this.default_action = fn;
		};

		return (
			<form className={form_classes} onSubmit={search_submit}>
				<Dropdown
					className="ad_search_dropdown"
					isOpen={show_popover}
					toggle={close}
				>
					<DropdownToggle tag="div">
						<input
							ref={set_search_input_ref}
							onKeyDown={arrow_nav}
							autoComplete="off"
							id={search_id}
							placeholder={placeholder}
							type="text"
							value={search_value}
							onChange={search}
							className={input_classes}/>
					</DropdownToggle>
					<DropdownMenu flip={false} className="pl-4 pl-md-0 ad_width_350px">
						<SearchResult
							set_focuser={set_focuser}
							focus_search_input={focus_search_input}
							on_action={this.props.on_action}
							query={this.state.query}
							market={this.props.market}
							set_default_action={set_default_action}
						/>
					</DropdownMenu>
				</Dropdown>
			</form>
		)
	}
}

const SearchField = connect(
	(state) => ({me: state.me})
)((props) => <TraksConsumer><SearchFieldImpl {...props}/></TraksConsumer>);

export default SearchField;



// WEBPACK FOOTER //
// ./src/c/SearchField.js